import { Card, Title } from '@yoast/ui-library';
import cx from 'classnames';

export default function CardHeader({
  children,
  description,
  title,
}: {
  children?: React.ReactNode;
  description?: string | React.ReactNode;
  title?: string | React.ReactNode;
}) {
  return (
    <Card.Header className="yst-h-auto yst-flex-col yst-items-start yst-gap-0 yst-border-b-[1px] yst-border-b-slate-200 yst-bg-white yst-py-8">
      {title && (
        <Title className={cx({ 'yst-mb-3': description || children })}>
          {title}
        </Title>
      )}
      {description && <p>{description}</p>}
      {children}
    </Card.Header>
  );
}
